import Image from "../fragments/Image";
import Gallery from "../fragments/Gallery";
import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect } from "react";

export default function Images({ block }) {

    const [blockLoaded, setBlockLoaded] = useState(false);

    useEffect(() => {
        setBlockLoaded(true);
    }, []);

    const leftMediaRevealRef = useReveal({ once: true });
    const rightTextRevealRef = useReveal({ once: true });

    return (
        <div className={`c-page__block c-page__block--images`}>
            <div className={`l-grid`}>
                <div className={`l-grid__col l-grid__col--m-6-12 c-transition-in l-bottom-mobile-section-space`} ref={leftMediaRevealRef}>
                    <Image 
                        src={block.left_img_src || []} 
                        width={block.left_img_width} 
                        height={block.left_img_height} 
                        alt={block.left_img_alt || ''} 
                    />
                </div>
                <div className={`l-grid__col l-grid__col--m-6-12 c-transition-in`} ref={rightTextRevealRef}>
                    <Image 
                        src={block.right_img_src || []} 
                        width={block.right_img_width} 
                        height={block.right_img_height} 
                        alt={block.right_img_alt || ''} 
                    />
                </div>
            </div>
        </div>
    );

}